export class VerificationDmatFormDto {
    participantNumber: string;
    participantName: string;
    dateOfBirth: string; 
    examDate: string; 
    kernPr: string;
    kernScore: string;
    fachPr: string;
    fachScore: string;
    fachmodul: string;
}
